import { createSlice } from "@reduxjs/toolkit";
import {
  DeleteTemplateParameterType,
  Inspection,
  StatusCount,
  ViewInspectionPageState,
} from "./ViewInspectionPage.type";

// ==============================|| VIEWS - PAGES - VIEW INSPECTION - REDUCER ||============================== //

const initialState = {
  Data: [] as Array<Inspection>,
  PageSize: 10,
  TotalRecordsCount: 0,
  StatusCounts: [] as Array<StatusCount>,
  deletedSuccessfully: false,
} as ViewInspectionPageState;

export const viewInspectionSlice = createSlice({
  name: "viewInspection",
  initialState,
  reducers: {
    setViewInspectionInitState: (
      state: ViewInspectionPageState,
      action: { payload: ViewInspectionPageState; type: string }
    ) => {
      return {
        ...state,
        Data: action.payload.Data,
        PageSize: action.payload.PageSize,
        TotalRecordsCount: action.payload.TotalRecordsCount,
        StatusCounts: action.payload.StatusCounts,
      };
    },
    setDeletedSuuccessfully: (
      state: ViewInspectionPageState,
      action: { payload: boolean }
    ) => {
      state.deletedSuccessfully = action.payload;
    },
    resetViewInspectionInitState: (state: ViewInspectionPageState) => {
      return {
        ...initialState,
      };
    },
  },
});

export const {
  setViewInspectionInitState,
  setDeletedSuuccessfully,
  resetViewInspectionInitState,
} = viewInspectionSlice.actions;

export const viewInspectionPageReducer = viewInspectionSlice.reducer;
